<template>
  <div class="t1">
    <div class="nav">
      <nav_list :index="1"></nav_list>
    </div>

    <div class="order-body">
      <sidebar def="bus_list"></sidebar>

        <div class="listbody">

   

<template v-if="gcurr == 0">
  <hot_line_list 
    :list="list" 
    @do-urgent="do_urgent"
    @show-ticket="show_ticket"
    @jump="jump"
     @show-point="show_point"
    @show-back="show_back"
    @show-note="show_note"
     @change-page="change_page"
    >
  </hot_line_list>
</template>


<!--------gooods ------>



<template v-if="gcurr == 1">
  <goods_order_list 
    :list="list" 
    :pagination="pagination"
    @jump="jump"
    @apply-refund="openKkdayRefundDialog"
    @show-back="show_back"
    @show-note="show_note"
    @change-page="change_page">
  </goods_order_list>
</template>

      </div>
    </div>

    <el-dialog :title="$lang(69656)" :visible.sync="refund_show" custom-class="modern-dialog">
      <div class="dialog-content" v-if="refund_show">
        <div class="info-row">
          <span class="label">{{ row.order.sn }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(69657) }}</span>
          <span class="value">{{ refund_info.y }} {{ refund_info.inc }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(50955) }}</span>
          <span class="value">
            <template v-if="refund_info.itm">
              {{ refund_info.y }}{{ refund_info.order.amount - refund_info.inc }}
            </template>
            <template v-else>
              {{ $lang(69660) }}
            </template>
          </span>
        </div>
        <div class="button-row">
          <el-button type="success" @click="refund_show = false">{{ $lang(51619) }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="$lang(50942)" :visible.sync="show" custom-class="modern-dialog">
      <div class="dialog-content">
        <div class="info-row">
          <span class="label">{{ row.order.sn }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(50952) }}</span>
          <span class="value">{{ row.y }} {{ row.order.amount }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(50949) }}</span>
          <span class="value">{{ $lang(50951) }} x {{ row.itm.rate }}% + {{ $lang(50950) }} x {{ row.y }}{{ row.itm.inc }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(50954) }}</span>
          <span class="value">{{ row.y }} {{ row.back_monty }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(50955) }}</span>
          <span class="value">{{ row.y }} {{ row.rate_amount }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ $lang(50953) }}</span>
          <span class="value">{{ row.y }} {{ row.real_back_monty }}</span>
        </div>
        <div class="button-row">
          <el-button type="success" @click="back_sbmt">{{ $lang(50133) }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="申请退款" :visible.sync="kkdayRefundDialogVisible" width="520px">
      <div class="refund-form" v-if="kkdayRefundDialogVisible">
        <div class="info-row">
          <span class="label">订单号</span>
          <span class="value">{{ kkdayRefundOrder ? kkdayRefundOrder.sn : '-' }}</span>
        </div>
        <div class="info-row">
          <span class="label">订单总额</span>
          <span class="value">¥{{ kkdayRefundInfo.total_price || '0.00' }}</span>
        </div>
        <div class="info-row">
          <span class="label">退款金额</span>
          <span class="value refund-amount">¥{{ kkdayRefundInfo.refund_amount || '0.00' }}</span>
        </div>
        <div class="refund-rule-card" v-if="kkdayRefundInfo.refund_rule">
          <div class="refund-rule-title">退款说明</div>
          <div class="refund-rule">
            {{ kkdayRefundInfo.refund_rule }}
          </div>
        </div>
        <div class="refund-field">
          <div class="refund-label">取消原因</div>
          <el-select v-model="kkdayRefundReason" placeholder="请选择取消原因" style="width: 100%;">
            <el-option
              v-for="reason in kkdayCancelReasons"
              :key="reason.value"
              :label="reason.label"
              :value="reason.value"
            />
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeKkdayRefundDialog">取消</el-button>
        <el-button type="primary" :loading="kkdayRefundSubmitting" @click="submitKkdayRefund">提交申请</el-button>
      </div>
    </el-dialog>

    <point_tc :id="0" ref="pot_tc"> </point_tc>
    <ticket_tc   ref="ticket_tc"> </ticket_tc>
  </div>
</template>

<script>
import sidebar from "./sidebar.vue";
import breadcrumb from "./breadcrumb.vue";
import nav_list from "./nav_list.vue";
import bus_order_list from "@/components/bus_order_list.vue";
import hot_line_list from "@/components/hot_line_list.vue";
import goods_order_list from "@/components/goods_order_list.vue";
export default {
  name: "bus_list",

  components: {
    sidebar,
    breadcrumb,
    nav_list,
    bus_order_list,
    hot_line_list,
    goods_order_list
  },

  data() {
    return {
      a: "bus_list",
      list: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      page: 1,
      s: -1,
    
      show: false,
      gcurr: 0,
      row: {
        order: {},
        plan: {},
        contact: [],
        itm: {},
        rate: 1,
        curr_amount: 0,
        back_monty: 0,
        real_back_monty: 0,
        rate_amount: 0,
        y: "",
      },
      index: -1,
      back: {
        type: 0,
        contact_ids: [],
      },
      refund_show: false,
      refund_info: {},
      kkdayRefundDialogVisible: false,
      kkdayRefundSubmitting: false,
      kkdayRefundOrder: null,
      kkdayRefundReason: '',
      kkdayRefundInfo: {
        total_price: '0.00',
        refund_amount: '0.00',
        refund_rule: '',
      },
      kkdayCancelReasons: [
        { value: 'MC001', label: '行程变更或取消' },
        { value: 'MC002', label: '重复订购' },
        { value: 'MC003', label: '价格因素' },
        { value: 'MC004', label: '个人因素' },
        { value: 'MC005', label: '交通因素' },
        { value: 'MC006', label: '联系不上店家' },
        { value: 'MC999', label: '其他' },
      ],
    };
  },
  mounted(e) {
    if (this.$route.query.s) {
      this.s = this.$route.query.s;
    } 
    if (this.$route.query.t) {
      const currentTab = parseInt(this.$route.query.t, 10);
      this.gcurr = currentTab === 2 ? 1 : currentTab;
    } 
    document.title = this.web_tit;
    this.re();
  },

  watch: {
    '$route.query': {
      handler(newQuery) {
        if (newQuery.s !== undefined) {
          this.s = newQuery.s;
        }
        if (newQuery.t !== undefined) {
          const currentTab = parseInt(newQuery.t, 10);
          this.gcurr = currentTab === 2 ? 1 : currentTab;
        }
        this.re();
      
      },
      deep: true
    }
  },

  methods: {
  
    	re() {
					this.page = 1
					this.list = []
          this.pagination = {
            current_page: 1,
            per_page: 10,
            total: 0,
          }
					this.f5()
				},
    onChange(index) {
      this.gcurr = index;
      this.re()
    },
    to_hi (datetime) {
      return datetime
      if (!datetime) {
        return ''
      }
      return datetime.substr(0, 16)
    },
	  set_status(i) {
				this.s = i.v
				this.re()
			},
    update_back_amount() {
      let n = 0;
      if (this.back.type) {
        let s = 0;

        for (let j in this.row.contact) {
          if (this.row.contact[j].is_select) {
            s += parseFloat(this.row.contact[j].price);
            n += 1;
          }
        }
        this.row.back_monty = s;
      } else {
        for (let j in this.row.contact) {
          if (this.row.contact[j].disabled == false) {
            n += 1;
          }
        }

        this.row.back_monty = this.row.curr_amount;
      }

      // this.row.back_monty = this.decimal(this.row.back_monty * this.row.rate)
      if (this.row.back_monty > this.row.curr_amount) {
        this.row.back_monty = this.row.curr_amount;
      }

      this.row.rate_amount = this.decimal(
        (this.row.back_monty * this.row.itm.rate) / 100 + n * this.row.itm.inc,2);
      this.row.real_back_monty = this.decimal(
        this.row.back_monty - this.row.rate_amount
      );
    },
    change_type(e) {
      // alert(e)
    },
    back_sbmt() {
      this.get("/order/sbmt_back", { id: this.row.order.id }, "post").then(
        (e) => {
          this.list[this.index]["back_status"] = 1;
          this.list[this.index]["strs"]["back_status"] = e.str;

          this.$message(this.$lang(50132));
          // this.row = e
          // this.row.back_monty = this.row.curr_amount
          // if (this.row.order.near_day <= this.row.plan.day_cannot) {
          //   this.$message(this.$lang(50943))
          //   // return
          // }
          // this.update_back_amount()
          this.show = false;
        }
      );
    },
    show_note(i) {
      console.log(this.list);
      this.index = i;
      let id = this.list[i].id;
      if (this.list[i].back_status == 4) {
        this.$message(this.list[i].back_note);
        return;
      }

      this.get("/order/refund_info", { id: id }, "post").then((e) => {
        this.refund_show = true;
        this.refund_info = e;
      });
    },
    show_back(i) {
      this.index = i;
      let id = this.list[i].id;
      this.get("/order/back_info", { id: id }, "post").then((e) => {
        this.row = e;
        this.row.back_monty = this.row.curr_amount;
        if (this.row.order.near_day <= this.row.plan.day_cannot) {
          this.$message(this.$lang(50943));
          // return
        }
        this.update_back_amount();
        this.show = true;
      });
    },
    show_point(id) {
      // alert(id)
      
      this.$refs.pot_tc.f5(id);
    },
    show_ticket(id) {

      this.$refs.ticket_tc.f5(id);
    },
    openKkdayRefundDialog(order) {
      if (!order || !order.sn) {
        this.$message.error('缺少订单信息');
        return;
      }
      this.kkdayRefundSubmitting = true;
      this.get('/kkday/orders/refund/calculate', {
        sn: order.sn,
      }, 'get', false).then((response) => {
        if (!response || !response.can_refund) {
          this.$alert((response && response.refund_rule) || '该订单不支持退款', '无法退款', {
            confirmButtonText: '确定',
          });
          return;
        }
        this.kkdayRefundOrder = order;
        this.kkdayRefundReason = '';
        this.kkdayRefundInfo = {
          total_price: response.total_price || '0.00',
          refund_amount: response.refund_amount || '0.00',
          refund_rule: response.refund_rule || '',
        };
        this.kkdayRefundDialogVisible = true;
      }).catch(() => {
        this.$message.error('获取退款信息失败');
      }).finally(() => {
        this.kkdayRefundSubmitting = false;
      });
    },
    closeKkdayRefundDialog() {
      this.kkdayRefundDialogVisible = false;
      this.kkdayRefundOrder = null;
      this.kkdayRefundReason = '';
      this.kkdayRefundInfo = {
        total_price: '0.00',
        refund_amount: '0.00',
        refund_rule: '',
      };
    },
    submitKkdayRefund() {
      if (!this.kkdayRefundOrder || !this.kkdayRefundOrder.sn) {
        this.$message.error('缺少订单信息');
        return;
      }
      if (!this.kkdayRefundReason) {
        this.$message.warning('请选择取消原因');
        return;
      }
      this.kkdayRefundSubmitting = true;
      const reasonItem = this.kkdayCancelReasons.find((item) => item.value === this.kkdayRefundReason);
      this.get('/kkday/orders/refund', {
        sn: this.kkdayRefundOrder.sn,
        reason: reasonItem ? reasonItem.label : '',
        cancel_type: this.kkdayRefundReason,
      }, 'post', false).then((response) => {
        if (response && response.refund_status === 'pending') {
          this.$message.success('退款申请已提交');
          this.closeKkdayRefundDialog();
          this.f5();
          return;
        }
        this.$message.error((response && response.message) || '提交失败');
      }).catch(() => {
        this.$message.error('提交失败，请稍后重试');
      }).finally(() => {
        this.kkdayRefundSubmitting = false;
      });
    },
    change_page(e) {
      this.page = e;
      this.f5();
    },
    hot_f5() {
				this.get("/v4/my_order", {
					page: this.page,
					status: this.s
				}, 'post').then((e) => {
					 
						this.list =e.list.data
            this.pagination = {
              current_page: e.list.current_page || 1,
              per_page: e.list.per_page || 10,
              total: e.list.total || 0,
            }
					
					this.page = e.list.current_page + 1
				});
			},
    kkday_order() {
      const params = {
        per_page: 10,
      };
      if (this.page > 1) {
        params.page = this.page;
      }
      if (this.s && this.s !== -1 && this.s !== 'all') {
        params.status = this.s;
      }
      this.get('/kkday/orders', params, 'get', false).then((e) => {
        this.list = e && e.orders ? e.orders : [];
        const pagination = e && e.pagination ? e.pagination : {};
        this.pagination = {
          current_page: pagination.current_page || 1,
          per_page: pagination.per_page || 10,
          total: pagination.total || this.list.length || 0,
        };
      });
    },
    f5() {
      this.$forceUpdate()
      if (this.gcurr == 0) {
					this.hot_f5()
					return
				}
      if (this.gcurr == 1) {
        this.kkday_order()
        return
      }
        return
      this.get(
        "/order/my_order",
        { page: this.page, status: this.s },
        "post"
      ).then((e) => {
        this.list = []
        for (let i in e.list.data) {
						let row = e.list.data[i]
						row.startdate = row.startdate.split(' ')
						row.enddate = row.enddate.split(' ')[1]
						row.starttitle = this.autoWrapText(row.starttitle, 10)
						row.endtitle = this.autoWrapText(row.endtitle, 10)

          this.list.push(row)
        }
        this.page = e.list.current_page;
      });
    },
    autoWrapText(span, maxWidth) {
      return span
        return span.substring(maxWidth)
			},
    do_urgent(i) {
      let id = this.list[i].id;
      this.get("/order/urgent", { id: id }, "post").then((e) => {
        this.list[i].is_urgent = 1;

        this.$message({
          type: "success",
          message: this.$lang(42643),
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
  max-height: 300px;
  overflow: hidden;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  max-height: 0;
  overflow: hidden;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
  max-height: 0;
}

.refund-form .refund-rule-card {
  margin: 4px 0 8px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
}

.refund-form .refund-rule-title {
  margin-bottom: 8px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.refund-form .refund-rule {
  color: #475569;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.refund-form .refund-field {
  margin-top: 16px;
}

.refund-form .refund-label {
  margin-bottom: 8px;
  color: #1f2937;
  font-weight: 600;
}

.refund-form .refund-amount {
  color: #dc2626;
  font-weight: 700;
}

.order-body {
  display: flex;
  width: min(100%, 1360px);
  margin: 30px auto;
  padding: 0 24px;
  gap: 24px;
  align-items: flex-start;
  box-sizing: border-box;
}

.listbody {
  min-width: 0;
  flex: 1 1 auto;
}

@media (max-width: 1366px) {
  .order-body {
    width: 100%;
    padding: 0 16px;
    gap: 16px;
    margin: 24px auto;
  }
}

@media (max-width: 1180px) {
  .order-body {
    padding: 0 12px;
    gap: 12px;
  }
}

.flex_between {
  display: flex;
  justify-content: space-between;
  align-items: center;
} 

.modern-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}

.dialog-content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  .label {
    flex: 0 0 150px;
    color: #606266;
    font-size: 14px;
  }

  .value {
    flex: 1;
    color: #303133;
    font-size: 14px;
    font-weight: 500;
  }
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/bus_list.vue